export const ITERABLE_API_HOST = process.env.API_HOST;
export const ITERABLE_LINKS_HOST = process.env.LINKS_HOST;

/** Docs */
const DOCS_PATH = '/api/docs';
export const ITERABLE_API_DOCS_URL = `https://${ITERABLE_API_HOST}${DOCS_PATH}`;
